import {ThunkAction, ThunkDispatch as OriginalThunkDispatch} from "redux-thunk";
import {rootReducer} from "../reducers";
import {StateType} from "typesafe-actions";
import {ReactNode} from "react";
import {RootAction} from "../actions";
import {OfficialProductType} from "./users";
import {Routes, RouteType} from "../utils/router";

export type RootState = StateType<typeof rootReducer>;

export type ThunkResult<R> = ThunkAction<R, RootState, undefined, RootAction>;
export type ThunkDispatch = OriginalThunkDispatch<RootState, undefined, RootAction>;

export type JustChildren = { children: ReactNode };

export interface LocationState {
    from?: string;
}

export interface UserProfileData {
    name?: string;
}

export const ProductRouteMap: Record<OfficialProductType, RouteType> = {
    data_api: Routes.DATA,
    timestamp_api: Routes.TIMESTAMP,
    webpage_api: Routes.HTML,
    document_api: Routes.PDF,
    document_aes_api: Routes.AES,
    document_aes_api_preservation: Routes.AES,
    document_simple_api: Routes.PDF_SIMPLE,
    document_simple_otp_api: Routes.PDF_SIMPLE_OTP,
}

export const ProductOrder: OfficialProductType[] = ["document_api", "document_aes_api", "document_simple_api", "webpage_api", "data_api", "timestamp_api"];

